import PageableCollection from 'backbone.paginator';

import DropdownSelections from 'app/collections/dropdown_selections';

export const DEFAULT_PAGE_SIZE = 20;

export const PAGING_TYPES = {
  PER_PAGE: 'perPage',
  ID: 'id',
};

export default PageableCollection.extend({
  mode: 'infinite',
  pagingType: PAGING_TYPES.ID,
  firstFetchSuccess: false,

  state: {
    pageSize: DEFAULT_PAGE_SIZE,
  },

  queryParams: {
    pageSize() { return this.pagingType === PAGING_TYPES.ID ? 'page_size' : 'per_page'; },
    currentPage() { return this.pagingType === PAGING_TYPES.ID ? null : 'page'; },
  },

  constructor(models, options = {}) {
    this.listenToOnce(this, 'sync', () => { this.firstFetchSuccess = true; });
    if (options.pageSize) this.state.pageSize = options.pageSize;
    this.dropdownSelections = options.dropdownSelections || new DropdownSelections([]);
    this.listenTo(this.dropdownSelections, 'change', this.resetToFirstPage);
    PageableCollection.prototype.constructor.call(this, models, options);
  },

  fetch(options) {
    const thisOptions = { data: this.paramsForFetch(), reset: true, ...options };
    return PageableCollection.prototype.fetch.call(this, thisOptions);
  },

  parseLinks(resp) {
    if (!resp.has_more) return {};

    let queryString;
    if (this.pagingType === PAGING_TYPES.ID) {
      const items = resp[this.key];
      queryString = `before_id=${items[items.length - 1].id}`;
    } else if (this.pagingType === PAGING_TYPES.PER_PAGE) {
      queryString = `page=${this.state.currentPage + 1}`;
    } else {
      throw new Error('This pagingType is not supported');
    }
    return { next: `${this.url}?${queryString}` };
  },

  parseRecords(response) {
    return response[this.key];
  },

  getNextPage() {
    // check that the current page is loaded before getting next page
    if (this.state.lastPage === this.state.currentPage) {
      PageableCollection.prototype.getNextPage.call(this);
    }
  },

  paramsForFetch() {
    return this.dropdownSelections.reduce((o, dropdownSelection) => ({
      ...o, ...dropdownSelection.getParams(),
    }), { ...this.additionalParamsForFetch() });
  },

  additionalParamsForFetch() {
    return {};
  },

  resetToFirstPage() {
    this.fullCollection.reset();
    this.getFirstPage({ fetch: true });
  },

  searchById(id, apiModeSelection) {
    const self = this;
    new this.model({ id }).fetch({
      data: { ...apiModeSelection.getParams() },
      success(model) {
        self.fullCollection.reset([model]);
      },
      error() {
        self.fullCollection.reset();
        self.trigger('sync');
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/collections/pageable_base.js